export default __webpack_public_path__ + "static/media/thue_xe_oto_tu_lai_di_du_lich_gia_re.fde3ac82.png";